import styled from 'styled-components';

export const ContainerNew = styled.div`
  padding: 0 30px;
  margin-top: 146px;

  @media screen and (min-width: 1280px) {
    margin-top: 196px;
    max-width: 1440px;
  }
`;

export const MenuTitle = styled.h1`
  color: black;
  font-family: 'Playfair Display';
  font-size: 27px;
  text-align: center;
  line-height: normal;
  @media screen and (min-width: 768px) {
    font-size: 32px;
  }
`;

export const MenuTitleCategory = styled.h2`
  color: black;
  font-family: 'Playfair Display';
  font-size: 29px;
  text-align: center;
  line-height: normal;
  @media screen and (min-width: 768px) {
    font-size: 36px;
  }
`;

export const ContainerMenu = styled.div`
  /* display: flex;
  justify-content: center; */
  margin-top: 50px;

  @media screen and (min-width: 1280px) {
    margin-top: 70px;
  }
`;

export const MenuList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px;
  margin-top: 30px;
`;

export const MenuListItem = styled.li`
  border: 1px solid #a4907c;
  border-radius: 8px;
  padding: 20px;
  width: 510px;
`;

export const MenuListItemTitle = styled.p`
  color: black;
  font-family: 'Playfair Display', sans-serif;
  font-size: 27px;
  line-height: normal;
  @media screen and (min-width: 768px) {
    font-size: 32px;
  }
`;

export const MenuListItemPrice = styled.p`
  color: black;
  font-family: 'Playfair Display', sans-serif;
  font-size: 27px;
  text-align: center;
  line-height: normal;
  @media screen and (min-width: 768px) {
    font-size: 32px;
  }
`;

export const PriceBox = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;

export const MenuListDiscr = styled.ul`
  display: flex;
  /* flex-direction: column; */
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 10px;
  margin-top: 25px;
`;

export const MenuListDiscrItem = styled.li``;

export const MenuListDiscrItemText = styled.p`
  color: black;
  font-family: 'Aboreto', sans-serif;
  font-size: 17px;
  line-height: normal;

  @media screen and (min-width: 768px) {
    font-size: 20px;
  }
`;

export const MenuBox = styled.div`
  margin-bottom: 60px;
`;

// export const MenuList = styled.ul``;
// export const MenuList = styled.ul``;
// export const MenuList = styled.ul``;
// export const MenuList = styled.ul``;
// export const MenuList = styled.ul``;
// export const MenuList = styled.ul``;
